module.exports = __webpack_public_path__ + "static/media/TK.a8167618.png";